import BaseInputField from '../../../../legacy-library/webcomponents/_form/input-field/input-field.class';
import style from '../input-field/input-field.css';

export default class DiscountField extends BaseInputField {
    properties() {
        return {
            ...super.properties(),
            externalValidity: false,
        };
    }

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('input-field');
    }

    styles() {
        return [style];
    }

    get isValid() {
        return this.externalValidity;
    }

    onBlur() {
        this.valid = this.isValid;
    }

    clearInput() {
        this.$refs.input.value = '';
        this.touched = false;
    }
}
